import React from 'react';
import { Lock } from 'lucide-react';

/**
 * EscrowNote — small reassurance line rendered below payment buttons.
 * Purely presentational.
 */
export function EscrowNote({ t, testIdSuffix = 'default' }) {
  const tr = (key, fallback) => (t ? (t(key) || fallback) : fallback);
  return (
    <div
      className="mt-2 flex items-start gap-1.5 text-[10px] text-slate-500 leading-snug"
      data-testid={`escrow-note-${testIdSuffix}`}
    >
      <Lock size={11} className="text-emerald-500 mt-0.5 shrink-0" />
      <span>
        {tr(
          'trust_escrow_payment',
          'Sichere Zahlung an 366transfer. Ihr Fahrer wird von uns bezahlt nach Ihrer sicheren Ankunft.'
        )}
      </span>
    </div>
  );
}
